// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopPartnerAuthControllerAuthorizeData } from './EshopPartnerAuthControllerAuthorizeData.gen';
import type { EshopPartnerAuthControllerAuthorizeErrors } from './EshopPartnerAuthControllerAuthorizeErrors.gen';
import type { EshopPartnerAuthControllerAuthorizeResponses } from './EshopPartnerAuthControllerAuthorizeResponses.gen';
import type { EshopPartnerAuthControllerGetClientInfoData } from './EshopPartnerAuthControllerGetClientInfoData.gen';
import type { EshopPartnerAuthControllerGetClientInfoErrors } from './EshopPartnerAuthControllerGetClientInfoErrors.gen';
import type { EshopPartnerAuthControllerGetClientInfoResponses } from './EshopPartnerAuthControllerGetClientInfoResponses.gen';
import type { Options } from './Options.gen';

export class EshopPartnerAuthController {
    /**
     * Issue a single-use authorization code for a partner service.
     *
     * Called by the eshop frontend on behalf of a logged-in customer after consent.
     */
    public static authorize<ThrowOnError extends boolean = false>(options: Options<EshopPartnerAuthControllerAuthorizeData, ThrowOnError>) {
        return (options.client ?? client).post<EshopPartnerAuthControllerAuthorizeResponses, EshopPartnerAuthControllerAuthorizeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/partner-auth/authorize',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Look up a partner's display name and requested scopes for the consent screen.
     *
     * Validates clientId + redirectUri up front (same check as authorize()) without creating an authorization code, so the eshop frontend can show the customer who they are about to grant access to, and fail fast on a bad clientId/redirectUri before rendering consent.
     */
    public static getClientInfo<ThrowOnError extends boolean = false>(options: Options<EshopPartnerAuthControllerGetClientInfoData, ThrowOnError>) {
        return (options.client ?? client).get<EshopPartnerAuthControllerGetClientInfoResponses, EshopPartnerAuthControllerGetClientInfoErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/partner-auth/client-info',
            ...options
        });
    }
}
